import { differenceInMinutes } from 'date-fns';
export var diffInMinutesBetweenTimes = function (firstTime, secondTime) {
    // arrival(departure).date may be empty
    var anyDay = '01.01.2000 ';
    return differenceInMinutes(Date.parse("".concat(anyDay).concat(firstTime)), Date.parse("".concat(anyDay).concat(secondTime)));
};
